module.exports = __webpack_public_path__ + "img/protea-background.b6f8abcd.png";